import React, { Component } from 'react';

export default class LumpsumBlog extends Component {
  render() {
    return (
      <div className="card">
      <div className="header">
        <h4>Lumpsum Investment</h4>
      </div>
      <div className="content">
        <h5 className="text-info">What is Lumpsum Investment?</h5>
        <p>A lumpsum investment refers to depositing the entire amount at one go 
          in a particular scheme for a specific duration</p>
        <p> Best lump sum investment is the one that helps the investor in planning their 
          personal finances and achieving their goals in the desired time-frame. This lump sum 
          calculator is for illustration purposes and to demonstrate to investors what their 
          investment returns could be like if they would invest in lumpsum</p>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Finance/LumpsumForm/LumpsumBlog.js